<template>
  <Transition name="fade" mode="out-in">
    <component :is="getComponent" />
  </Transition>
</template>

<script>
import AuthForm from "@/components/parts/auth/AuthForm.vue";
import AuthMessage from "@/components/parts/auth/AuthMessage.vue";
import AuthRestore from "@/components/parts/auth/AuthRestore.vue";
import {getComponent} from "@/mixins/getComponent";
export default {
  name: 'AuthBlock',
  components: {
    AuthRestore,
    AuthForm,
    AuthMessage
  },
  mixins: [getComponent],
}
</script>
